function getEnumValue<T>(
  enumObject: T,
  key: string | undefined
): T[keyof T] | undefined {
  if (!key) return undefined
  return enumObject[key as keyof T]
}

function getEnumKeyByValue<T extends Record<string, string>>(
  enumObject: T,
  value: string
): keyof T | undefined {
  return Object.keys(enumObject).find(
    (key) => enumObject[key as keyof T] === value
  ) as keyof T | undefined
}

function getEnumValueByValue<T extends Record<string, string>>(
  enumObject: T,
  value: string
): T[keyof T] | undefined {
  const key = getEnumKeyByValue(enumObject, value)
  return key ? enumObject[key] : undefined
}

function isEmailValid(email?: string): boolean {
  if (!email) return false
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  return emailRegex.test(email)
}

export { getEnumValue, getEnumKeyByValue, getEnumValueByValue, isEmailValid }
